import { Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { first, uniq } from 'lodash-es';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {
	private history: string[] = [];
	private defaultUrl = '/';

	constructor(private router: Router) {
		const navStart: Observable<Event> = router.events.pipe(
			filter((event: Event) => event instanceof NavigationEnd),
		);

		navStart.subscribe((event: any) => {
			this.history = uniq([event.url, ...this.history]);
		});
	}

	back() {
		this.history = this.history.slice(1);
		const url = first(this.history) || this.defaultUrl;
		this.router.navigateByUrl(url);
	}
}
